export default __webpack_public_path__ + "static/media/berlinsignet_light.df2bebfd.png";